const emojiMap = {'angry':'angry 😡','disgustful':'disgustful 🤢','fearful':'fearful 😰','happy':'happy 😃','neutral':'neutral 😐','sad':'sad 😭','surprised':'surprised 😲'}

export default emojiMap;